const OAUTH_KEYS = ['access_token', 'refresh_token', 'user_id', 'gmail_connected'] as const;

/**
 * Parse OAuth callback params (access_token, refresh_token, user_id, gmail_connected).
 * The backend puts them in the URL fragment (#) so tokens never reach server logs;
 * the query string (?) is still read as a fallback for the older redirect format.
 */
export function parseOAuthParams(): {
  access_token: string;
  refresh_token: string;
  user_id: string;
  gmail_connected: boolean;
} | null {
  const hash = new URLSearchParams(window.location.hash.slice(1));
  const params = hash.get('access_token') ? hash : new URLSearchParams(window.location.search);
  const access_token = params.get('access_token');
  const refresh_token = params.get('refresh_token');
  const user_id = params.get('user_id');
  if (!access_token || !refresh_token || !user_id) return null;
  return {
    access_token,
    refresh_token,
    user_id,
    gmail_connected: params.get('gmail_connected') === 'true',
  };
}

/** Remove OAuth params from the browser URL (fragment and query) without triggering a navigation */
export function cleanOAuthParams(): void {
  const url = new URL(window.location.href);
  OAUTH_KEYS.forEach((key) => url.searchParams.delete(key));
  url.hash = '';
  window.history.replaceState({}, '', url.toString());
}
